import React, { createContext, useContext } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  // Always dark mode — no toggle
  const isDarkMode = true;
  const toggleTheme = () => {};

  // Create dark theme
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: 'dark',
          primary: {
            main: '#8A2BE2', // Blue Violet
            light: '#A35EFF',
            dark: '#6B24B2',
            contrastText: '#fff',
          },
          secondary: {
            main: '#FF4081', // Pink accent
            light: '#FF79B0',
            dark: '#C60055',
            contrastText: '#fff',
          },
          background: {
            default: '#121212',
            paper: '#1A1A1A',
          },
          text: {
            primary: '#ffffff',
            secondary: 'rgba(255, 255, 255, 0.7)',
          },
        },
        shape: {
          borderRadius: 8,
        },
        components: {
          MuiPaper: {
            styleOverrides: {
              root: {
                backgroundImage: 'none',
              },
            },
          },
          MuiAppBar: {
            styleOverrides: {
              root: {
                background: 'rgba(18, 18, 18, 0.95)',
                backdropFilter: 'blur(10px)',
              },
            },
          },
          MuiDrawer: {
            styleOverrides: {
              paper: {
                backgroundColor: '#1a1a1a',
                backdropFilter: 'blur(10px)',
              },
            },
          },
          MuiBottomNavigation: {
            styleOverrides: {
              root: {
                background: '#1a1a1a',
                backdropFilter: 'blur(10px)',
              },
            },
          },
          MuiCard: {
            styleOverrides: {
              root: {
                backgroundColor: '#1a1a1a',
                backdropFilter: 'blur(10px)',
              },
            },
          },
          MuiButton: {
            styleOverrides: {
              root: {
                textTransform: 'none',
                borderRadius: 8,
              },
            },
          },
          MuiChip: {
            styleOverrides: {
              root: {
                borderRadius: 6,
              },
            },
          },
        },
      }),
    []
  );

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
